import React, { FC, useState, ReactElement } from 'react';
import { currentUUID, fileSizeCheck } from 'src/utils/common';
import './style.scss';
import { errorModalViewStore } from 'src/store/modal';

interface Props {
  attachState: any;
  setAttachState: any;
  subDesc?: ReactElement;
}

const InputBox: FC<Props> = ({ attachState, setAttachState, subDesc }) => {
  const [isActive, setActive] = useState(false);
  const setModalState = errorModalViewStore((state: any) => state.set);

  const handleDragStart = () => {
    setActive(true);
  };
  const handleDragEnd = () => {
    setActive(false);
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
    setActive(true);
  };
  const handleDrop = (event: any) => {
    event.preventDefault();
    setActive(false);
    const attachFile = event.dataTransfer.files;
    uploadFiles(attachFile);
  };

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    uploadFiles(e.target.files);
    e.target.value = '';
  };

  const uploadFiles = (fileList: FileList | null) => {
    // Preserve the files before resetting the input clears its live FileList.
    const attachFile = Array.from(fileList || []);
    if (attachFile.length === 0) return;
    if (!attachFile.every(file => fileSizeCheck(file, setModalState))) return;

    const idx = currentUUID();
    setAttachState({ files: [...attachState.files, { idx, attachFile }] });
  };

  return (
    <div className={['_attach_dtop_box'].join(' ')}>
      <label
        className={`preview${isActive ? ' active' : ''}`}
        onDragEnter={handleDragStart}
        onDragOver={handleDragOver}
        onDragLeave={handleDragEnd}
        onDrop={handleDrop}
      >
        <input type="file" className="file" onChange={e => handleUpload(e)} />
        <div className="_label_div">
          <div className="_icon">
            <i className="ri-download-2-fill" />
          </div>
          <div className="preview_msg">클릭 혹은 파일을 이곳에 드롭하세요.</div>
          {subDesc ? <div className="_sub_desc">{subDesc}</div> : ''}
        </div>
      </label>
    </div>
  );
};

export default InputBox;
